import util from '@/libs/util'

//吐槽列表
export function messagePage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/message/page',
    params
  })
}

// 新增吐槽
export function messageAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/message',
    data
  })
}
